import React from 'react'
import { WorkModel } from '@Entities/work/work'
import { RightsholderClaimedShare } from '@Entities/rightsholder'
import { useNavigate } from 'react-router'
import WorkItem from '@Components/WorkItem/index'

interface WorkItemWrapperProps {
    data: WorkModel
    rightsHolderId?: number
    publicSearchType?: boolean
    catalogType?: boolean
    historyType?: boolean
    draftType?: boolean
    claimType?: boolean
    claimedShare?: RightsholderClaimedShare
    handleDeleteDraft?: () => void
    selectWorkForMatching?: (songCode: string, title: string) => void
    selectWorkForClaiming?: (propertyId: number | null | undefined) => void
}

/**
 * @deprecated Use WorkItemV2 instead
 */
const WorkItemWrapper = (props: WorkItemWrapperProps) => {
    const navigate = useNavigate()
    const {
        data,
        rightsHolderId,
        publicSearchType,
        catalogType,
        historyType,
        draftType,
        claimType,
        claimedShare,
        handleDeleteDraft,
        selectWorkForMatching,
        selectWorkForClaiming,
    } = props

    return (
        <WorkItem
            data={data}
            rightsHolderId={rightsHolderId}
            publicSearchType={publicSearchType}
            catalogType={catalogType}
            historyType={historyType}
            draftType={draftType}
            claimType={claimType}
            claimedShare={claimedShare}
            handleDeleteDraft={handleDeleteDraft}
            selectWorkForMatching={selectWorkForMatching}
            selectWorkForClaiming={selectWorkForClaiming}
            navigate={navigate}
        />
    )
}

export default WorkItemWrapper
